import CopyAll from '@mui/icons-material/CopyAll'
import { IconButton } from '@mui/material'
import React from 'react'
import { copyToClipBoard, formatPhoneNumber } from 'src/consumer/helpers/utilFunctions'

export default function ContactDetailsTableItem({bookedEventInfo,  isTableItem=false}) {
    const patientInfo = bookedEventInfo?.patientInfo
    const TableComp = isTableItem ? 'td' : React.Fragment

    if (!!patientInfo?.mobile) {
      const phoneDetails = formatPhoneNumber(patientInfo?.mobile)
      return (
        <TableComp>
          <div className="d-flex align-items-center gap-1">
            <span>
              <span>
                {phoneDetails?.formattedPhoneNumber ? (
                  <>
                    <span style={{ color: '#8f8f9f' }}>({phoneDetails.countryCode})</span>{' '}
                    <span>{phoneDetails.formattedPhoneNumber}</span>
                  </>
                ) : (
                  <>
                    <span>{phoneDetails.concatenatedString}</span>
                  </>
                )}
                <IconButton
                  className="flex-shrink-0"
                  onClick={(event) => {
                    event.stopPropagation()
                    copyToClipBoard('Mobile', patientInfo?.mobile)
                  }}
                >
                  <CopyAll />
                </IconButton>
              </span>
            </span>
          </div>
        </TableComp>
      )
    }

    return (
      <TableComp>
        <div className='d-flex gap-1 flex-wrap-1 align-items-center'>
          <strong>Email: </strong>
          <div>
        {patientInfo?.email ? (
          <div className="d-flex align-items-center gap-1">
            <span>
              <span>{patientInfo?.email}</span>
              <IconButton
                className="flex-shrink-0"
                onClick={(event) => {
                  event.stopPropagation()
                  copyToClipBoard('Email', patientInfo?.email)
                }}
              >
                <CopyAll />
              </IconButton>
            </span>
          </div>
        ) : (
          <div>No contact info</div>
        )}
        </div>
        </div>
      </TableComp>
    )
  }
